import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("rc_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("rc_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("rc_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("rc_token");
        localStorage.removeItem("rc_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = (token, u) => {
    localStorage.setItem("rc_token", token);
    localStorage.setItem("rc_user", JSON.stringify(u));
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("rc_token");
    localStorage.removeItem("rc_user");
    setUser(null);
    window.location.href = "/login";
  };

  return <AuthCtx.Provider value={{ user, loading, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const portalFor = (role) => {
  if (role === "buyer") return "/buyer/home";
  if (role === "crm_executive") return "/crm/dashboard";
  if (role === "crm_manager" || role === "management") return "/management/dashboard";
  return "/login";
};
